import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29,20H5.41l2-2H23.56a2,2,0,0,0,1.9-1.37l2.66-9A2,2,0,0,0,26.23,5H7a2.09,2.09,0,0,0-.51.07L3.71,2.29A1,1,0,0,0,2.29,3.71L5.07,6.49A2.09,2.09,0,0,0,5,7v9a2,2,0,0,0,.4,1.19l-3.11,3.1a1,1,0,0,0,0,1.42A1,1,0,0,0,3,22H29a1,1,0,0,0,1-1v0A1,1,0,0,0,29,20Z"/><circle cx="7" cy="27" r="3"/><circle cx="25" cy="27" r="3"/>';
export var CartSVG = function CartSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
CartSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CartSVG);